export class RefundRequestInput {
    Amount: number;
    IBAN: string;
    Message: string;

    constructor(){}
}